// extracted by mini-css-extract-plugin
module.exports = {"search-switch":"list_search-switch__3x7Ya","header-off":"list_header-off__2Jt5O","layui-form-label":"list_layui-form-label__e9vWM"};